import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet/components/Box';
/*import { Text } from 'grommet/components/Text';*/
import { ERRORMESSAGE } from '../Constants.js';
import NuovaPassword from '../Components/NuovaPassword';
import InserisciOTPPassword from '../Components/InserisciOTPPassword';
import RiepilogoOTP from '../Components/RiepilogoOTP';
import { VerifyOtpPasswordCtrl } from '../Controllers/otpCtrl/VerifyOtpPasswordCtrl';
import { passwordRegex } from '../Utils/Utility';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { logout } from '../Utils/Utility';*/



/*class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo ? <Text className='error'>{this.props.testo}</Text> : <Text className='errorhide2'></Text>}
            </Box>
        );
    }
}*/


class ModificaPasswordSteps extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            msgPassOld: '',
            msgPassNew: '',
            msgPassConf: '',
            msgOtp: '',
            errorOtp: false,
            otp: '',
            confirmNewPassword: '',
            pwdValid: false,
            oldPwdValid: false,
            confPwdValid: false,
            disableButtonNewPwd: true,
            buttonStateOtp: false,
            dataOTP: false,
            errorOld: false,
            errorNew: false,
            errorConf: false,
            step: 1,
            status: '',
            showTimeoutModal: false,
            loading: false,
            updatePassword: this.props.updatePassword !== undefined && this.props.updatePassword ? true : false

        }
        this.setOldPassword = this.setOldPassword.bind(this);
        this.setNewPassword = this.setNewPassword.bind(this);
        this.setConfirmPassword = this.setConfirmPassword.bind(this);
        this.otpProcess = this.otpProcess.bind(this);
        this.setOtp = this.setOtp.bind(this);
    }


    /* ////////////////////////////////////////////// start controls password //////////////////////////////////////////// */

    setOldPassword(e) {
        var pwd = e.target.value;
        var newPassword = this.state.newPassword;
        this.setState({
            oldPassword: pwd
        }, this.compareNewAndOld(newPassword, pwd))
    }

    setNewPassword(e) {
        var pwd = e.target.value;
        var old = this.state.oldPassword;
        this.setState({
            newPassword: pwd
        },
            this.validNewPassword(pwd, old),
        )
    }

    setConfirmPassword(e) {
        var confPwd = e.target.value;
        var pwdValid = this.state.pwdValid;
        var newPwd = this.state.newPassword;
        this.setState({
            confirmNewPassword: confPwd
        },
            this.compareNewAndConf(newPwd, confPwd, pwdValid)
        )
    }

    compareNewAndConf(newPwd, confPwd, pwdValid) {
        /*var pwdValid = pwdValid;*/
        var oldPwdValid = this.state.oldPwdValid;
        if (newPwd !== confPwd) {
            this.setState({
                errorConf: true,
                confPwdValid: false,
                msgPassConf: ERRORMESSAGE.msgpassconf
            }, this.activeBtn(pwdValid, oldPwdValid, false))
        } else {
            this.setState({
                errorConf: false,
                confPwdValid: true,
                msgPassConf: ''
            }, this.activeBtn(pwdValid, oldPwdValid, true))
        }
    }

    compareNewAndOld(newPwd, oldPwd) {
        var pwdValid = this.state.pwdValid;
        var confPwdValid = this.state.confPwdValid;
        if (oldPwd === '') {
            this.setState({
                errorOld: true,
                oldPwdValid: false,
                msgPassOld: ERRORMESSAGE.msgblank
            }, this.activeBtn(pwdValid, false, confPwdValid))
        } else if (oldPwd.length < 8 || oldPwd.length > 20) {
            this.setState({
                errorOld: true,
                oldPwdValid: false,
                msgPassOld: ERRORMESSAGE.msgErrorReq
            }, this.activeBtn(pwdValid, false, confPwdValid))
        } else {
            this.setState({
                errorOld: false,
                oldPwdValid: true,
                msgPassOld: ''
            }, this.activeBtn(pwdValid, true, confPwdValid))
        }

        if (newPwd === oldPwd) {
            this.setState({
                errorNew: true,
                oldPwdValid: false,
                pwdValid: false,
                msgPassNew: ERRORMESSAGE.msgpassold
            }, this.activeBtn(pwdValid, false, confPwdValid))
        }
    }

    activeBtn(pwdValid, oldPwdValid, confPwdValid) {

        if (oldPwdValid && pwdValid && confPwdValid) {
            this.setState({
                disableButtonNewPwd: false
            })
        } else {
            this.setState({
                disableButtonNewPwd: true
            })
        }
    }

    validNewPassword(pwd, old) {
        var msg = '';
        var pass = false;
        var confPwd = this.state.confirmNewPassword;

        if (pwd === '') {

            msg = ERRORMESSAGE.msgblank;
            pass = false;

        } else if (pwd === old) {

            msg = ERRORMESSAGE.msgpassold;
            pass = false;

        } else if (pwd !== '' && !passwordRegex.test(pwd)) { // Validazione password

            msg = ERRORMESSAGE.msgErrorReq;
            pass = false;

        } else if (pwd !== '' && passwordRegex.test(pwd)) {

            msg = '';
            pass = true;

        }

        this.setState({
            msgPassNew: msg,
            pwdValid: pass,
            errorNew: !pass
        }, this.compareNewAndConf(pwd, confPwd, pass))
    }

    /* ////////////////////////////////////////////// end controls password //////////////////////////////////////////// */



    nextStep = () => {
        const { step } = this.state
        this.setState({
            step: step + 1
        })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({
            step: step - 1
        })
    }

    handleChange = input => event => {
        this.setState({ [input]: event.target.value })
    }


    firstStep = () => {
        this.setState({
            step: 1,
        })
    }

    setOtp = (e) => {
        var otpVal = e.target.value;
        if (/^\d{6,6}$/.test(otpVal)) {
            this.setState({
                otp: otpVal,
                buttonStateOtp: false,
                msgOtp: ''
            })
        } else {
            this.setState({
                otp: otpVal,
                buttonStateOtp: true,
                msgOtp: 'Inserire 6 cifre'
            })
        }
    }

    otpProcess() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        VerifyOtpPasswordCtrl(function (data) {
            self.setState({
                dataOTP: data,
                status: 200,
                loading: false
            }, self.nextStep())
        }, function (status, error) {
            self.setState({
                status: status,
                loading: false
            }, function () {
                if (status === 500 && error === '400 null') {
                    this.setState({
                        msgOtp: 'Vecchia password errata! Modificarla e riprovare!'
                    })
                } else if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                    self.nextStep();
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                } else if (status === 406 && error === '5704') {
                    this.setState({
                        msgOtp: 'Codice OTP scaduto',
                        errorOtp: true
                    })
                }  else if (status === 406 && error === '5707') {
                    this.setState({
                        msgOtp: 'Codice OTP non valido',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5708') {
                    this.setState({
                        msgOtp: 'Ultimo tentativo prima del blocco utenza',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5709') {
                    this.setState({
                        msgOtp: 'Utenza bloccata',
                        errorOtp: false
                    })
                } else {
                    self.setState({
                        msgOtp: 'Si è verificato un errore, riprovare!',
                        errorOtp: true
                    })
                }
            })

        }, this.state, token, ids)
    }


    form(step) {

        const { oldPassword, disableButtonNewPwd, newPassword, confirmNewPassword, dataOTP, otp, updatePassword, buttonStateOtp, msgOtp, errorOtp, status, showTimeoutModal, loading } = this.state;
        const values = { oldPassword, disableButtonNewPwd, newPassword, confirmNewPassword, dataOTP, otp, updatePassword, buttonStateOtp, msgOtp, errorOtp, status, showTimeoutModal, loading };
        // eslint-disable-next-line default-case
        switch (step) {
            case 1:
                return <NuovaPassword
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    setOldPassword={this.setOldPassword}
                    setNewPassword={this.setNewPassword}
                    setConfirmPassword={this.setConfirmPassword}
                    msgPassOld={this.state.msgPassOld}
                    msgPassNew={this.state.msgPassNew}
                    msgPassConf={this.state.msgPassConf}
                />
            case 2:
                return <InserisciOTPPassword
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    otpFunction={this.otpProcess}
                    setOtp={this.setOtp}
                    values={values}
                />
            case 3:
                return <RiepilogoOTP
                    firstStep={this.firstStep}
                    values={values}
                />
        }
    }


    render() {
        const { step } = this.state;


        return (

            <Box style={{ width: '100%' }}>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>

                        <Box direction='row'>
                            {this.form(step)}
                        </Box>
                    </Box>

                </Box>
            </Box>
        )
    }

}
export default ModificaPasswordSteps;